export default __webpack_public_path__ + "static/media/ic-payment-request.129840d8.svg";